export default {
  priv: 'pr_projects',
  overviewTitle: 'Projecten',
  detailTitle: 'Project',
  deleteTitle: 'dit project',
  url: '/projects',
  apiUrl: '/projects/',
  sortBy: ['created_timestamp'],
  sortDesc: [true],
  deletable: true,
  editable: true,
  filterName: 'projects',
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Project code',
      value: 'code'
    },
    {
      text: 'Klant',
      value: 'businessrelation_id',
      type: 'optionList',
      optionListName: 'businessrelations'
    },
    {
      text: 'Referentie code',
      value: 'reference_code'
    },
    {
      text: 'Referentie omschrijving',
      value: 'reference_description'
    }
  ],
  newRecord: {
    construction_site_address: {
      country_id: 56
    }
  },
  tableFields: [
    {
      text: 'Projectnummer',
      value: 'code',
      link: '/projects/{id}',
      width: '10%'
    },
    {
      text: 'Klant',
      value: 'businessrelation_name',
      link: '/sale/customers/{businessrelation_id}',
      width: '15%'
    },
    {
      text: 'Werf',
      value: 'construction_site',
      sortable: false,
      width: '20%'
    },
    {
      text: 'Referentie code',
      value: 'reference_code',
      sortable: false,
      width: '10%'
    },
    {
      text: 'Referentie omschrijving',
      value: 'reference_description',
      sortable: false,
      width: '15%'
    },
    {
      text: 'Referentie m²',
      value: 'reference_area',
      sortable: false,
      width: '10%'
    }
  ]
};
